import React from 'react';

const KPICard = (props) => {

  return (
    <div className="col-lg-3 col-sm-6 pt-2 text-center">
      <div className="card h-100 border-dark mb-3" style={{ backgroundColor: props.color ? props.color : '' }}>
        <div className="card-body text-center align-items-center justify-content-center" style={{ color: "#4d0077" }}>
          <h3 className="card-title">{props.kpi}</h3>
          <h6 className="card-text">{props.desc}</h6>
        </div>
      </div>
    </div>
  )

}

export default KPICard;

{/* <div className="card-body d-flex text-center align-items-center justify-content-center" style={{ color: "#4d0077" }}>
<h3 className="card-title m-auto">{props.kpi}</h3>
<div className="card-text m-auto">{props.desc}</div> */}